// arg: v-auto-focus:arg -> v-auto-focus:something = {arg: 'something', ...}
// modifiers: v-auto-focus.modifiers -> v-auto-focus.something = {modifiers: {something: true}, ...}

export default {
  // ...plus any other Vue directive methods

  // NOTE: The life cycle hooks can take up to 3 arguments: el, binding, vnode. In order to prevent warnings, their definition has been where they are not used. Feel free to add them if you need them inside any life cycle hooks.
  mounted(el: HTMLElement) {
    el.querySelector('input')?.focus()
  },

  // updated () {
  //   do something
  // },

  // beforeUnmount () {
  // do something
  // }
}
